import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/app/layout/AppLayout';
import { SessionGate } from '@/modules/identity/public';

/** Área logada. Sem sessão, manda para o login guardando a origem. */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: () => (
    <SessionGate>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </SessionGate>
  ),
});
